import Swiper from 'swiper';
import {
    Mousewheel,
    Pagination,
    Autoplay,
    Navigation
} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-cube';

const isFrontPage = $('body').hasClass('is-front-page');

function getPlayer(): 'youtube' | 'vk' {
    return 'vk'
}

if (isFrontPage) {
    const $window = $(window)

    $window.one("load", () => {

        let delay = 3000;
        $('#constructions .swiper-container').each((i, swiperContainer) => {
            new Swiper(swiperContainer, {
                modules: [Mousewheel, Pagination, Autoplay],
                // direction: 'vertical',
                slidesPerView: 1,
                spaceBetween: 0,
                // mousewheel: true,
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true,
                // },
                // effect: "cube",
                // coverflowEffect: {
                //     modifier: 3,
                //     slideShadows: false,
                // },
                // cubeEffect: {
                //     shadow: false,
                //     slideShadows: false,
                // },
                grabCursor: true,
                lazy: {
                    loadPrevNext: true
                },
                preloadImages: false,
                loop: true,
                autoplay: {
                    delay,
                },

            });
            delay += 500
        })

        const $photos = $('#photos')
        const $swiper = $photos.find('.swiper')

        if (!$swiper.find('.swiper-slide').length) {
            return
        }

        const photo_swiper = new Swiper($swiper.get(0), {
            modules: [Pagination, Navigation, Autoplay],
            centeredSlides: true,
            spaceBetween: 20,
            preloadImages: true,
            lazy: {
                loadPrevNext: true,
            },
            loop: true,
            pagination: {
                el: $photos.find('.swiper-pagination').get(0),
                clickable: true,
            },
            navigation: {
                nextEl: $photos.find('.swiper-button-next').get(0),
                prevEl: $photos.find('.swiper-button-prev').get(0),
            },
            autoplay: {
                pauseOnMouseEnter: true,
                delay: 3000,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 1.5,
                },
                992: {
                    slidesPerView: 2.5,
                },
            },
        })

        $swiper.mouseenter(function () {
            photo_swiper.autoplay.stop()
        })

        $swiper.mouseleave(function () {
            photo_swiper.autoplay.start()
        })


        // @ts-ignore
        // window.swiper = swiper
    })


    const player = getPlayer() //

    let video_api_loaded = false

    if ($('.video-iframe').length) {
        if (player === 'youtube') {
            // @ts-ignore
            window.onYouTubeIframeAPIReady = function () {
                video_api_loaded = true
            }

            const tag = document.createElement('script')
            tag.src = 'https://www.youtube.com/player_api'
            tag.async = true
            const firstScriptTag = document.getElementsByTagName('script')[0]
            // @ts-ignore
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
        }
        if (player === 'vk') {
            const tag = document.createElement('script')
            tag.src = 'https://vk.com/js/api/videoplayer.js'
            tag.async = true
            tag.onload = () => {
                console.warn('vk loaded')
                video_api_loaded = true
            }
            const firstScriptTag = document.getElementsByTagName('script')[0]
            // @ts-ignore
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
        }
    }


    $(function () {
        const $videos = $('#videos')
        const $swiper = $videos.find('.swiper')

        if (!$swiper.find('.swiper-slide').length) {
            return
        }

        let allow_autoplay = true

        let should_play_video = false

        const video_swiper = new Swiper($swiper.get(0), {
            modules: [Mousewheel, Pagination, Navigation, Autoplay],
            preloadImages: true,
            lazy: {
                loadPrevNext: true,
                // loadOnTransitionStart: true,
                loadPrevNextAmount: 1
            },
            centeredSlides: true,
            loop: true,
            pagination: {
                el: $videos.find('.swiper-pagination').get(0),
                clickable: true,
            },
            navigation: {
                nextEl: $videos.find('.swiper-button-next').get(0),
                prevEl: $videos.find('.swiper-button-prev').get(0),
            },
            autoplay: {
                pauseOnMouseEnter: true,
                delay: 3000
            },
            slideToClickedSlide: true,
            on: {
                slideChangeTransitionStart: function (swiper) {
                    stop_playing()
                    $videos.find('.video-cover').css('opacity', 1)
                    $videos.find('.video-iframe').addClass('d-none')
                },
                slideChangeTransitionEnd: function (swiper) {
                    if (should_play_video) {
                        // play_video($(swiper.clickedSlide))
                        should_play_video = false
                    }
                },
                init: function (swiper) {
                    $.each(swiper.slides, function (i, slide) {
                        $(slide).find('.video-iframe').attr('id', 'player-' + i)
                    })
                },
                // lazyImageReady: function (swiper, slide_el) {
                //     $(slide_el).find('.play-button').css('opacity', 1)
                // },
                // resize: function (swiper) {
                //     setTimeout(function () {
                //         $videos.find('.swiper-slide').css('width', '')
                //         swiper.update()
                //     }, 300)
                // },
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 1.5,
                },
                992: {
                    slidesPerView: 2.5,
                },
            },
        })

        $swiper.mouseenter(function () {
            video_swiper.autoplay.stop()
        })

        $swiper.mouseleave(function () {
            if (allow_autoplay) {
                video_swiper.autoplay.start()
            }
        })

        $(document).on('click', '#videos .slide-inner', function (event) {
            const $slide = $(event.target).closest('.swiper-slide')
            if ($slide.hasClass('swiper-slide-active')) {
                play_video()
            }
        })

        function stop_playing() {
            if (player === 'youtube') {
                // @ts-ignore
                if (window.YT && window.YT.get && video_swiper.slides) {
                    $.each(video_swiper.slides, function (i, slide) {
                        const player_id = $(slide).find('.video-iframe').attr('id')
                        // @ts-ignore
                        const player = window.YT.get(player_id)
                        if (player && player.stopVideo) {
                            player.stopVideo()
                        }
                    })
                }
            }

            if (player === 'vk') {
                // @ts-ignore
                if (window.VK && video_swiper.slides) {
                    $.each(video_swiper.slides, function (i, slide) {
                        // @ts-ignore
                        const iframe = $(slide).find('.video-iframe').get(0)
                        if (!iframe || !iframe.getAttribute('src')) {
                            return
                        }
                        // @ts-ignore
                        const player = VK.VideoPlayer(iframe)
                        // @ts-ignore
                        if (player && player.pause) {
                            player.pause()
                        }
                    })
                }
            }
        }

        // @ts-ignore
        window.player = null

        function play_video() {

            if (!video_api_loaded) {
                return
            }

            allow_autoplay = false

            const $slide = $swiper.find('.swiper-slide-active')
            const $video_cover = $slide.find('.video-cover').first()
            let $video_iframe = $video_cover.siblings('.video-iframe').first()

            if ($video_iframe.is('iframe')) {
                if (player === 'youtube') {
                    // @ts-ignore
                    const player = window.YT.get($video_iframe.attr('id'))
                    if (player && player.playVideo) {
                        player.playVideo()
                    }
                    $video_iframe.removeClass('d-none')
                    $video_cover.css('opacity', 0)
                    return
                }

                if (player === 'vk') {
                    // @ts-ignore
                    const player = VK.VideoPlayer($video_iframe.get(0))
                    if (player && player.play) {
                        player.play()
                    }


                    $video_iframe.removeClass('d-none')
                    $video_cover.css('opacity', 0)
                    return
                }

            }

            if (player === 'youtube') {
                let player_loading = true
                // @ts-ignore
                new YT.Player($video_iframe.get(0), {
                    videoId: $video_cover.attr('data-video-id'),
                    events: {
                        'onReady': function (event) {
                            $video_iframe = $(event.target.getIframe())
                            $video_iframe.removeClass('d-none')
                            $video_cover.css('opacity', 0)
                            event.target.playVideo()
                            player_loading = false
                        },
                    },
                    playerVars: {
                        'modestbranding': 1,
                        'enablejsapi': 1,
                        'controls': 2,
                        'origin': window.location.origin,
                        'rel': 0,
                        'showinfo': 0,
                    },
                })
            }

            if (player === 'vk') {
                const iframeEl = document.createElement('iframe');
                iframeEl.width = '736';
                iframeEl.height = '414';
                iframeEl.classList.add('video-iframe');
                iframeEl.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture;';
                // @ts-ignore
                iframeEl.allowfullscreen = true
                iframeEl.src = `https://vk.com/video_ext.php?${$video_cover.attr('data-video-id')}&js_api=1`;
                iframeEl.onload = (event) => {
                    const el = event.target
                    setTimeout(() => {
                            // @ts-ignore
                            const player = VK.VideoPlayer(el)
                            player.on('inited', (err) => {
                                console.warn('inited')
                            })

                            if (player && player.play) {
                                player.play()
                            }
                        }
                    )

                }
                $video_iframe.replaceWith(iframeEl)
            }

        }

    })

    // const $contactFormModal = $('#contact-form-modal')
    // const $contactForm = $contactFormModal.find('.contact-form')
    //
    // if ($contactForm.length) {
    //     const $btn = $contactForm.find('button.send')
    //     const $success = $contactForm.find('.success')
    //     const $error = $contactForm.find('.error')
    //
    //     const showError = (message) => {
    //         $error.text(message).removeClass('d-none')
    //     }
    //
    //     $btn.on('click', () => {
    //         $success.addClass('d-none')
    //         $error.addClass('d-none')
    //
    //         const $contact = $contactForm.find('.contact')
    //         const contact = $contact.val()
    //         const $message = $contactForm.find('.message')
    //         const message = $message.val()
    //
    //         if (!contact) {
    //             showError('Не указаны контактные данные')
    //             return
    //         }
    //
    //         if (!message) {
    //             showError('Не указано сообщение')
    //             return
    //         }
    //
    //         $btn.attr('disabled', 'disabled')
    //
    //         $.post(window.wpConfig.ajaxUrl, {
    //             action: 'contact_form',
    //             data: {
    //                 contact,
    //                 message
    //             }
    //         })
    //             .done(function (data) {
    //                 if (!data.success) {
    //                     showError(data.message)
    //                     return
    //                 }
    //                 $success.removeClass('d-none')
    //                 $message.val('')
    //                 $contact.val('')
    //             })
    //             .fail(function (xhr) {
    //                 showError(xhr.responseText)
    //             })
    //             .always(function () {
    //                 $btn.removeAttr('disabled')
    //             });
    //     })
    //
    //     $contactFormModal.on('hidden.bs.modal', function () {
    //         $success.addClass('d-none')
    //         $error.addClass('d-none')
    //     });
    // }

}


// const initCbForm = () => {
//     const $contactForm = $('.contacts form');
//     const $btn = $contactForm.find('button.send');
//     const $success = $contactForm.siblings('.success');
//     const $error = $contactForm.siblings('.error');
//
//     const showError = (message) => {
//         $error.text(message).slideDown();
//         $contactForm.slideUp();
//
//         setTimeout(() => {
//             $error.slideUp();
//             $contactForm.slideDown();
//         }, 2000)
//     }
//
//     $contactForm.on('keyup', function (event) {
//         if (event.keyCode === 13) {
//             $contactForm.find('.trigger-on-enter').trigger('click');
//         }
//     });
//
//     $contactForm.find('.send').on('click', () => {
//
//         const $contact = $contactForm.find('.contact')
//         const contact = $contact.val()
//         const $message = $contactForm.find('.message')
//         const message = $message.val()
//
//         if (!contact) {
//             showError('Не указаны контактные данные')
//             return
//         }
//
//         if (!message) {
//             showError('Не указано сообщение')
//             return
//         }
//
//         $btn.attr('disabled', 'disabled')
//
//         $.post(window.wpConfig.ajaxUrl, {
//             action: 'contact_form',
//             data: {
//                 contact,
//                 message
//             }
//         })
//             .done(function (data) {
//                 if (!data.success) {
//                     showError(data.message)
//                     return
//                 }
//                 $contactForm.slideUp();
//                 $success.slideDown();
//                 $message.val('')
//                 $contact.val('')
//
//                 setTimeout(() => {
//                     $success.slideUp();
//                     $contactForm.slideDown();
//                 }, 3000)
//             })
//             .fail(function (xhr) {
//                 showError(xhr.responseText)
//             })
//             .always(function () {
//                 $btn.removeAttr('disabled')
//             });
//
//         // $contactForm.slideUp();
//         // $success.slideDown();
//         // $error.slideDown();
//     })
//
// }
//
// if (isFrontPage) {
//     initCbForm();
// }
